<style>
</style>

<script>
	// @ is an alias to /src
	import HelloWorld from "@/components/HelloWorld.vue"

	export default {
		name: "Home",
		components: {
			HelloWorld
		}
	}
</script>

<template>
	<div>
		<div class="content-top">
			<h4>Home</h4>
			<small>Home Description.</small>
		</div>
		<div class="content-center">
		</div>
		<div class="content-bottom">
		</div>
	</div>
</template>
